import React, { FC } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import { ActionableSelectOption } from 'components/ActionableSelect/ActionableSelect';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

interface OpportunitiesAutocompleteProps {
  areOpportunitiesLoading: boolean;
  selectedOpportunity: ActionableSelectOption | null;
  parsedOpportunities: ActionableSelectOption[];
  createOpportunityOption: {
    id: string;
    label: string;
    onClick: () => void;
  };
  handleSearchChange: (value: string) => void;
  handleOnChangeOpportunity: (value: ActionableSelectOption) => void;
}

const OpportunitiesAutocomplete: FC<OpportunitiesAutocompleteProps> = ({
  areOpportunitiesLoading,
  selectedOpportunity,
  parsedOpportunities,
  createOpportunityOption,
  handleSearchChange,
  handleOnChangeOpportunity,
}) => {
  return (
    <Autocomplete
      value={selectedOpportunity}
      loading={areOpportunitiesLoading}
      options={
        selectedOpportunity && !parsedOpportunities.some(option => option.id === selectedOpportunity.id)
          ? [selectedOpportunity, ...parsedOpportunities, createOpportunityOption]
          : [...parsedOpportunities, createOpportunityOption]
      }
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => (
        <TextField {...params} label='Salesforce Opportunity' variant='outlined' style={{ width: 300 }} />
      )}
      renderOption={(props, option) => (
        <li {...props}>
          {option.onClick ? (
            <Box
              display={'flex'}
              alignItems={'center'}
              onClick={event => {
                event.stopPropagation();
                option.onClick && option.onClick();
              }}
            >
              <AddRoundedIcon sx={{ color: '#265183', marginRight: '8px' }} />
              {option.label}
            </Box>
          ) : (
            option.label
          )}
        </li>
      )}
      onInputChange={(event, value) => {
        handleSearchChange(value);
      }}
      onChange={(event, value) => {
        if (value) {
          handleOnChangeOpportunity(value);
        }
      }}
    />
  );
};

export default OpportunitiesAutocomplete;
